
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Head from "next/head"

import SEO from "@/meta/SEO"
import Default from "@/templates/Default"
import OrderPlacedView from "@/views/order-placed"

function OrderPlaced() {
  return (
    <>
      <Head>
        <title>Złożono zamówienie | fansi.pl</title>
        <SEO description="CART" />
        {/* <meta name="robots" content="noindex,nofollow" /> */}
      </Head>
      <OrderPlacedView />
    </>
  )
}

OrderPlaced.Layout = Default
export default OrderPlaced


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/order-placed',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  